<template>
	<div
			class="pumpkinWrap"
			@mouseenter="onPumpkinEnter"
			@mouseleave="onPumpkinLeave"
	>
		<div class="pumpkin-cat--3-"><svg-sprite width="46" height="46" icon-id="pumpkin-cat--3-" halloween/></div>
		<div class="pumpkin-cat--4-"><svg-sprite width="53" height="53" icon-id="pumpkin-cat--4-" halloween/></div>
		<div class="pumpkin-cat--5-"><svg-sprite width="40" height="40" icon-id="pumpkin-cat--5-" halloween/></div>

		<!-- Точка «парковки» мотылька у тыквы -->
		<div ref="spirit" class="spirit">
			<div class="spirit__flyer">
				<svg-sprite width="40" height="40" icon-id="spirit" halloween/>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "pumpkinWrap-halloween",

	data() {
		return {
			/* «воздушная» точка, куда взлетаем перед началом кружения */
			airTransform: 'translate(-12px, -78px)',

			/* @type {Animation|null} */
			takeoffAnim: null,
			/* @type {Animation|null} */
			landAnim: null
		};
	},

	methods: {
		onPumpkinEnter() {
			const host = this.$refs.spirit;
			if (!host) return;

			if (this.landAnim) {
				this.landAnim.cancel(); this.landAnim = null; 
			}

			const wrap = this.$el; // <-- було querySelector('.pumpkinWrap')

			if (wrap.classList.contains('is-flying')) return;

			const cs = getComputedStyle(host);
			const from = cs.transform === 'none' ? 'translate(0,0)' : cs.transform; // захист

			if (this.takeoffAnim) this.takeoffAnim.cancel();

			this.takeoffAnim = host.animate(
				[ { transform: from }, { transform: this.airTransform } ],
				{ duration: 550, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'forwards' }
			);

			this.takeoffAnim.onfinish = () => {
				wrap.classList.add('is-flying');
				this.takeoffAnim = null;
			};
		},

		onPumpkinLeave() {
			const host = this.$refs.spirit;
			if (!host) return;

			const wrap = this.$el; // <-- було querySelector('.pumpkinWrap')
			wrap.classList.remove('is-flying');

			if (this.takeoffAnim) {
				this.takeoffAnim.cancel(); this.takeoffAnim = null; 
			}
			if (this.landAnim) this.landAnim.cancel();

			const cs = getComputedStyle(host);
			const from = cs.transform === 'none' ? 'translate(0,0)' : cs.transform;

			this.landAnim = host.animate(
				[ { transform: from }, { transform: 'translate(0,0)' } ],
				{ duration: 520, easing: 'cubic-bezier(.3,.7,.2,1)', fill: 'forwards' }
			);

			this.landAnim.onfinish = () => {
				this.landAnim = null; 
			};
		},

		beforeDestroy() {
			if (this.takeoffAnim) this.takeoffAnim.cancel();
			if (this.landAnim) this.landAnim.cancel();
		}
	}

};
</script>

<style  lang="scss">
.workTableHead {
	position: relative;

	.pumpkin-cat--3-,
	.pumpkin-cat--4-,
	.pumpkin-cat--5-,
	.candle {
		position: absolute;
	}

	.pumpkin-cat--3- {
		top: -38px;
		left: 0px;
	}
	.pumpkin-cat--4- {
		top: -42px;
		left: 21px;
		z-index: 10;
	}
	.pumpkin-cat--5- {
		top: -33px;
		left: 52px;
		z-index: 5;
	}
	.candle {
		top: -38px;
		left: 140px;
	}
}

.pumpkinWrap {
	position: absolute;
	top: 0;
	left: 0;
}

/* Поставь духа туда, где он должен «сидеть» изначально */
.spirit {
	position: absolute;
	left: 28px;
	bottom: -10px;
	width: 40px;
	height: 40px;
	transform: translate(0, 0);
	will-change: transform;
	transition: transform .55s cubic-bezier(.2,.7,.2,1); // плавний взліт/посадка як fallback
}
.pumpkinWrap.is-flying .spirit {
	transform: translate(-12px, -78px); // синхронно з airTransform
}

.spirit__flyer {
	width: 100%;
	height: 100%;
	pointer-events: none;
	transform: translate(0,0);
	will-change: transform;
}

/* Пока ховер — крутимся вокруг точки зависания (в воздухе) */
.pumpkinWrap.is-flying .spirit__flyer {
	animation:
			spirit-fly 3600ms ease-in-out infinite,
			spirit-flutter 380ms linear infinite alternate;
}

/* Траектория вокруг «воздушной» точки (не парковки!) */
@keyframes spirit-fly {
	0%   { transform: translate( 0px,  0px) rotate(0deg); }
	20%  { transform: translate(18px, -10px) rotate(6deg); }
	40%  { transform: translate(32px,  6px) rotate(0deg); }
	60%  { transform: translate(18px, -12px) rotate(-6deg); }
	80%  { transform: translate(-8px,  8px) rotate(3deg); }
	100% { transform: translate( 0px,  0px) rotate(0deg); }
}

/* Лёгкое «трепыхание» */
@keyframes spirit-flutter {
	from { filter: drop-shadow(0 0 0 rgba(0,0,0,.15)); }
	to   { transform: translateY(-2px) rotate(2deg); filter: drop-shadow(0 2px 2px rgba(0,0,0,.25)); }
}

</style>
